export class CustomPickListValues{
    Id:  number | string | null;
    Tenant: number;
    Value: string | null;
    IsDeleted: boolean;
}